module.exports = __webpack_public_path__ + "static/img/鹏飞集团.c759832a.png";